import { render, staticRenderFns } from "./alternate_device.vue?vue&type=template&id=7ce5c45a&scoped=true&"
import script from "./alternate_device.vue?vue&type=script&lang=js&"
export * from "./alternate_device.vue?vue&type=script&lang=js&"
import style0 from "./alternate_device.vue?vue&type=style&index=0&id=7ce5c45a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce5c45a",
  null
  
)

export default component.exports